import {
  buildPrintDemandeWithTemplate,
  useDemandePrint,
  type DemandeStore,
  type PrintAction,
} from '@/features/interface/demande/shared'

export function useDemandeCAPPPrint(store: DemandeStore<'MODEL_CAPP'>) {

  const actionPrintCerfa: PrintAction = {
    mustSave: true,
    label: 'Générer le CERFA',
    jobs: buildPrintDemandeWithTemplate<'MODEL_CAPP'>({
      store,
      typeDocumentTemplate: 'Cerfa',
      filenameKeys: ['dispositif', 'id'],
    }),
  }

  return useDemandePrint<'MODEL_CAPP'>({
    store,
    getActions: () => [actionPrintCerfa],
  })
}
